import { render, staticRenderFns } from "./MarketingRuleForm.vue?vue&type=template&id=77f26b2a&"
import script from "./MarketingRuleForm.vue?vue&type=script&lang=js&"
export * from "./MarketingRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports